import isEmpty from "../../validation/is-empty";
import {
  LOGIN_INCORRECT_USERNAME_PASSWORD,
  LOGIN_SUCCESS,
  ACCOUNT_LOCKED,
  NETWORK_ERROR_LOGIN,
  SHOW_BALANCE_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
  REDEEM_LOYALTY_POINTS_SUCCESS,
  UPGRADE_WALLET_SUCCESS,
  REGENERATE_SECKEY_SUCCESS,
  VERIFY_OTP_SUCCESS,
  LOADING_LOGIN,
  ADDUPDATE_BP_SUCCESS,
  DELETE_PROFILE_PIC_SUCCESS,
  LOGIN_FAILED,
  WALLET_SETTING_SUCCESS,
  RESET_LOGIN,
  LOGIN_APPROVAL_PENDING,
  LOGIN_KYC_PENDING,
  LOGIN_KYB_PENDING,
  LOGIN_DEALER_MISSING,
  LOGIN_NOT_AVAILABLE,
} from "../types";

const initialState = {
  isLoading: false,
  isAvailable: false,
  isError: false,
  isLocked: false,
  success: false,
  status: "",
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_LOGIN:
      return {
        ...state,
        isLoading: true,
        isAvailable: false,
        isError: false,
        isLocked: false,
        success: false,
        status: "",
      };
    case LOGIN_INCORRECT_USERNAME_PASSWORD:
    case LOGIN_NOT_AVAILABLE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isAvailable: false,
        isLocked: false,
        data: action.payload,
        status: "Invalid username or password",
      };

    case LOGIN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        isLocked: false,
        isError: true,
        isAvailable: false,
        data: action.payload,
        status: "Login failed, Please try again",
      };

    // case LOGIN_NOT_AVAILABLE:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     isLocked: false,
    //     isError: true,
    //     isAvailable: false,
    //     status: "Not Available",
    //   };

    case LOGIN_APPROVAL_PENDING:
      return {
        ...state,
        isLoading: false,
        isLocked: false,
        isError: true,
        isAvailable: false,
        status: "Approval Pending",
        data: action.payload,
      };

    case LOGIN_KYC_PENDING:
      return {
        ...state,
        isLoading: false,
        isLocked: false,
        isError: true,
        isAvailable: false,
        status: "Kyc Pending",
        data: action.payload,
      };

    case LOGIN_KYB_PENDING:
      return {
        ...state,
        isLoading: false,
        isLocked: false,
        isError: true,
        isAvailable: false,
        status: "Kyb Pending",
        data: action.payload,
      };

    case LOGIN_DEALER_MISSING:
      return {
        ...state,
        isLoading: false,
        isLocked: false,
        isError: true,
        isAvailable: false,
        status: "Dealer Missing",
        data: action.payload,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isAvailable: !isEmpty(action.payload),
        data: action.payload,
        status: "",
        isLocked: false,
        success: true,
      };

    case UPGRADE_WALLET_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          kycAccountType: action.payload.levelNameKey.toUpperCase(),
        },
      };
    }

    case ACCOUNT_LOCKED:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isLocked: true,
        isAvailable: false,
        data: action.payload,
        status: "Your account is locked",
      };

    case NETWORK_ERROR_LOGIN:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isAvailable: false,
        isLocked: false,
        status: "Unable to connect to the server",
      };

    case SHOW_BALANCE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          walletAmount: action.payload.amount,
        },
      };

    case UPDATE_PROFILE_SUCCESS:
    case ADDUPDATE_BP_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          cust_profile_pic: action.payload.cust_profile_pic,
        },
      };
    }

    case DELETE_PROFILE_PIC_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          cust_profile_pic: "",
        },
      };

    case REDEEM_LOYALTY_POINTS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          walletAmount:
            +state.data.walletAmount + +action.payload.loyaltyAmount,
        },
      };

    case REGENERATE_SECKEY_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          secKey: action.payload.secKey,
        },
      };

    case VERIFY_OTP_SUCCESS:
      const typeVerified =
        action.otpType === "email" ? "isEmailVerified" : "isMobileVerified";
      return {
        ...state,
        data: {
          ...state.data,
          [typeVerified]: "Verified",
        },
      };

    case WALLET_SETTING_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          kycAccountType: action.payload.kycAccountType,
        },
      };
    }

    case RESET_LOGIN:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isLocked: false,
        status: "",
        networkError: "",
      };

    default:
      return state;
  }
};
